import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './account/Login';
import Signup from './account/Signup';
import ForgetPassword from './account/ForgetPassword';
import ResetPassword from './account/ResetPassword';
import Leads from './leads/Leads';
import Plan from './account/Plan';
import Success from './callback/success';
import Fail from './callback/fail';
import PricingPlan from './admin/PricingPlan';
import SucessAuth from './callback/sucess_auth';
import Finder from './leads/Finder';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/:email/reset-password" element={<ResetPassword />} />
        <Route path="/leads" element={<Leads />} />
        
        <Route path="/plan" element={<Plan />} />
        <Route path="/callback/success" element={<Success />} />
        <Route path="/callback/fail" element={<Fail />} />
        <Route path="/auth/success" element={<SucessAuth />} />
        
        
      </Routes>
    </Router>
  );
}

export default App;
